import productive from "../assets/cred/productive.gif"
import underoneroof from "../assets/cred/underoneroof.gif";
import collaborate from "../assets/cred/collaborate.gif"

const handleScroll = (page) => {
    const e1 = document.getElementsByClassName('cred-inner-container')[0];
    const e2 = document.getElementsByClassName('cred-description')[0];

    // const host = (process.env.REACT_APP_MODE == 'dev') ? 'http://127.0.0.1/' : process.env.REACT_APP_HOST

    // reached bottom of last container
    if (e2.scrollTop >= 1504.800048828) {
      if (page == 'home')
        window.location.replace(`https://revirt-pvt.vercel.app/#fourth`)
      else  
        window.location.replace(`https://revirt-pvt.vercel.app/${page}#fourth`)
    }
    // let total = e1.scrollTop + e1.clientHeight;
    // if (e2.scrollTop >= e2.clientHeight)
      // console.log(e2.offsetHeight);

    var observer1 = new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting === true) {
        document
          .getElementsByClassName("gif-container")[0]
          .setAttribute("src", collaborate);
        return;
      }
    },
    { threshold: [1] }
  );

  observer1.observe(document.querySelector("#cred-1"));

  var observer2 = new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting === true) {
        document
          .getElementsByClassName("gif-container")[0]
          .setAttribute("src", productive);
        return;
      }
    },
    { threshold: [1] }
  );

  observer2.observe(document.querySelector("#cred-2"));

  var observer3 = new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting === true) {
        document
          .getElementsByClassName("gif-container")[0]
          .setAttribute("src", underoneroof);

        
        return;
      }
    },
    { threshold: [1] }
  );

  observer3.observe(document.querySelector("#cred-3"));
};

export default handleScroll